'use client';

import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/lib/ThemeContext';
import { LanguageProvider } from '@/lib/LanguageContext';
import ThemedToaster from '@/components/ui/ThemedToaster';

export default function Providers({ children }) {
  // useState ensures the QueryClient is created once per browser session,
  // not on every render.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { refetchOnWindowFocus: false, retry: 1 },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <LanguageProvider>{children}</LanguageProvider>
        {/* Toaster has to be INSIDE ThemeProvider so it can read the
            active theme and re-render when the user toggles. */}
        <ThemedToaster />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
